import { locales } from "configs/i18n";
import i18next from "i18next";

i18next.addResources(locales.EN, "SELECT_CTA", {
  SELECT:
    "Change the text variables to the correct type (0 is variable, 1 is still and 2 is CTA)",
  SUBMIT: "Submit changes",
});
